export function getCookie(cname: any) {
  if (typeof window === "undefined") return "";
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function setCookie(cname: any, cvalue: any, exdays: number) {
  if (typeof window === "undefined") return;
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  document.cookie = `${cname}=${cvalue};expires=${d.toUTCString()};path=/`;
}

export async function clearCookie() {
  await fetch(
    `${process.env.server_url_report}/api/updateprofile?access_token=${process.env.public_token}`,
    {
      method: "POST",
      credentials: "omit",
      headers: {
        "content-type": "application/json",
        "Access-Control-Allow-Credentials": "true",
        Accept: "application/json",
      },
    }
  );
}
